import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AccountService, AuthenticateUserCommand } from "./api-account.service";
import { RegisterAccess } from "../../../app/shared/Entities/RegisterAccess";
import { CriarCompromissoSignature } from "../../../app/shared/Signature/CriarCompromissoSignature";
import { AtualizarCompromissoSignature } from "../../../app/shared/Signature/AtualizarCompromissoSignature";
import { AlocaUsuarioResponsavelSignature } from "../../../app/shared/Signature/AlocaUsuarioResponsavelSignature";

@Injectable({
  providedIn: 'root'
})

export class AccountDataService {

  constructor(private api: AccountService) {
  }

  public SingIn(command: AuthenticateUserCommand, skipAuth: boolean = false): Observable<any> {
    return this.api.SingIn(command, skipAuth);
  }
}
